(function () {
  'use strict';

  var isScrolling = false;

  function isSamePageLink(link) {
    if (!link.hash) return false;
    try {
      var url = new URL(link.href, window.location.href);
      return url.pathname === window.location.pathname && url.search === window.location.search;
    } catch (e) {
      return false;
    }
  }

  function getStickyHeaderHeight() {
    var header = document.querySelector('.header-section header[is="sticky-header"]');
    return header ? header.getBoundingClientRect().height : 0;
  }

  function releaseLock() {
    isScrolling = false;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="#shopify-section-"]');
    if (!link || !isSamePageLink(link)) return;

    var target;
    try {
      target = document.querySelector(link.hash);
    } catch (e) {
      return;
    }
    if (!target) return;

    event.preventDefault();

    // Empêche un nouveau défilement de démarrer tant que le précédent
    // n'est pas terminé (évite les sauts erratiques en cas de double-clic
    // ou de clics répétés pendant l'animation).
    if (isScrolling) return;
    isScrolling = true;

    var topGap = 20;
    var targetTop = window.scrollY + target.getBoundingClientRect().top - getStickyHeaderHeight() - topGap;
    var motionReduced = !!(window.theme && window.theme.config && window.theme.config.motionReduced);
    var behavior = motionReduced ? 'auto' : 'smooth';

    window.scrollTo({
      top: targetTop,
      behavior: behavior
    });

    // Note : on ne met volontairement pas à jour l'URL visible (pas de
    // history.pushState) pour ne pas afficher l'identifiant technique de
    // la section dans la barre d'adresse. Le défilement fonctionne
    // exactement pareil sans ça.

    if (behavior === 'auto') {
      releaseLock();
    } else if ('onscrollend' in window) {
      window.addEventListener('scrollend', releaseLock, { once: true });
      // Filet de sécurité si l'événement scrollend ne se déclenche jamais
      // (ex: la cible est déjà à la bonne position, aucun scroll ne démarre).
      setTimeout(releaseLock, 1200);
    } else {
      // Navigateurs sans support de scrollend : durée fixe généreuse.
      setTimeout(releaseLock, 800);
    }
  });
})();
